export const init = () => {
  CUBE.Analytics.enhanced.plv2.es6.initImpression('#CrossSellFloor','cross-sell');
  CUBE.Analytics.enhanced.plv2.es6.initImpression('.our-suggestions__bottom','cross-sell');
};



// WEBPACK FOOTER //
// ./src/analytics/enhanced/ec-impression-cross-sell.js